import styled from 'styled-components';

const InfoRow = styled.div`
`;

const VehicleWrapper = styled.div`
  ${InfoRow}:not(:last-child) {
    margin-bottom: 16px;
  }
`

const InfoRowTitle = styled.h3``;

const InfoRowData = styled.div``;

const ListWrapper = styled.div`
  max-height: 30vh;
  overflow-y: auto;
  
  > button {
    width: 100%;
    border: 1px solid black;
    padding: 16px;
    
    background: none;
  }
`;

export const Styled = {
  InfoRow,
  InfoRowTitle,
  InfoRowData,
  ListWrapper,
  VehicleWrapper
};
